import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { showOverflowDrawer } from '../../../toolbox/functions.web';
import Icon from '../../icons/components/Icon';
const useStyles = makeStyles((theme) => {
    return {
        contextMenuItem: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            minHeight: '40px',
            padding: '10px 16px',
            boxSizing: 'border-box',
            '& > *:not(:last-child)': {
                marginRight: `${theme.spacing(3)}px`
            },
            '&:hover': {
                backgroundColor: theme.palette.ui04
            }
        },
        contextMenuItemDisabled: {
            pointerEvents: 'none'
        },
        contextMenuItemDrawer: {
            padding: '12px 16px'
        },
        contextMenuItemIcon: {
            '& svg': {
                fill: theme.palette.icon01
            }
        }
    };
});
const ContextMenuItem = ({ accessibilityLabel, className, customIcon, disabled, id, icon, onClick, onKeyDown, onKeyPress, testId, text, textClassName }) => {
    const styles = useStyles();
    const _overflowDrawer = useSelector(showOverflowDrawer);
    return (React.createElement("div", { "aria-disabled": disabled, "aria-label": accessibilityLabel, className: clsx(styles.contextMenuItem, _overflowDrawer && styles.contextMenuItemDrawer, disabled && styles.contextMenuItemDisabled, className), "data-testid": testId, id: id, key: text, onClick: disabled ? undefined : onClick, onKeyDown: disabled ? undefined : onKeyDown, onKeyPress: disabled ? undefined : onKeyPress },
        customIcon ? customIcon
            : icon && React.createElement(Icon, { className: styles.contextMenuItemIcon, size: 20, src: icon }),
        React.createElement("span", { className: textClassName !== null && textClassName !== void 0 ? textClassName : '' }, text)));
};
export default ContextMenuItem;
